import { DOMAIN_HOST_BY_LOCALES } from 'config';
import { LOCALE } from 'helpers/i18n';

const getDomain = () => DOMAIN_HOST_BY_LOCALES[LOCALE];
export const getMetaOrigin = () => `https://www.${getDomain()}`;
